import { NavLink } from "react-router-dom";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./PrescriptionRenewalsViewNavigationBar.module.scss";

interface IPrescriptionRenewalsViewNavigationBarProps {
    prescriptionRenewalId: string;
}

function PrescriptionRenewalsViewNavigationBar(props: IPrescriptionRenewalsViewNavigationBarProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <>
            <NavLink
                className={({ isActive }) => `${styles.navigationLink} ${isActive ? styles.active : ""}`}
                to={`/prescriptionrenewals/${props.prescriptionRenewalId}/renewMedication`}
            >
                {getText("RenewMedicationLabel")}
            </NavLink>

            <NavLink
                className={({ isActive }) => `${styles.navigationLink} ${isActive ? styles.active : ""}`}
                to={`/prescriptionrenewals/${props.prescriptionRenewalId}/medicationHistory`}
                data-cy="prescriptionRenewals-medicationHistoryTab"
            >
                {getText("MedicationHistoryLabel")}
            </NavLink>

            <NavLink
                className={({ isActive }) => `${styles.navigationLink} ${isActive ? styles.active : ""}`}
                to={`/prescriptionrenewals/${props.prescriptionRenewalId}/results`}
            >
                {getText("ResultsLabel")}
            </NavLink>
        </>
    );
}

export { PrescriptionRenewalsViewNavigationBar };
